import * as Dialog from "@radix-ui/react-dialog";
import closeIcon from "../assets/images/close.svg";
import { useState } from "react";

export default function PhoneVerificationModal({
  open,
  onOpenChange,
  onVerify,
  onResend,
  error,
  authLoading,
  loading,
}) {
  const [otp, setOtp] = useState("");
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        {/* Overlay */}
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex sm:items-center sm:justify-center items-end justify-center">
          {/* Modal Content: bottom sheet on mobile, card on desktop */}
          <Dialog.Content
            className="sm:max-w-md sm:max-w-[400px] sm:mx-4 sm:rounded-2xl rounded-t-2xl bg-white px-4 pt-3 pb-6 shadow-xl relative flex flex-col
              sm:bottom-auto sm:translate-y-0 bottom-0 translate-y-0
              animate-in fade-in-90 slide-in-from-bottom-8"
            style={{ maxWidth: "100vw" }}
          >
            <Dialog.Close asChild>
              <button
                className="absolute top-4 outline-none right-4 text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full"
                aria-label="Close"
              >
                {/* Local close.svg asset */}
                <img src={closeIcon} alt="Close" className="w-6 h-6" />
              </button>
            </Dialog.Close>
            <div className="flex flex-col">
              <div className="w-12 h-1.5 bg-gray-200 rounded-full m-auto mb-4 sm:hidden" />
              <h2 className="text-base sm:text-lg font-semibold text-gray-900 mb-1 mt-0 sm:mt-2">
                Phone verification
              </h2>
              <div className="w-full h-px bg-gray-300 my-4" />
              <p className="text-xs sm:text-sm text-gray-600 mb-6">
                A verification code has been sent to your phone number. Please
                enter this code to complete your verification process.
              </p>
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                // const code = e.target.elements.code.value;
                onVerify(otp);
                console.log("Submitted");
              }}
              className="flex flex-col gap-3"
            >
              <label
                className="text-xs text-gray-700 mb-1"
                htmlFor="verification-code"
              >
                Verification Code
              </label>
              <input
                id="verification-code"
                name="code"
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                maxLength={6}
                className={`rounded-md border px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-indigo-400 ${
                  error ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="Enter Code"
                required
              />
              {error && (
                <span className="text-xs text-red-500 mt-1 ml-1">{error}</span>
              )}
              <button
                type="submit"
                className="w-full flex items-center justify-center gap-2 uppercase font-bold bg-purpleGradient text-white px-4 py-3 rounded-lg hover:bg-purpleGradientDark transition-colors disabled:bg-none disabled:bg-gray-300"
              >
                {authLoading || loading ? "Verifying..." : "Verify Code"}
              </button>
            </form>
            <div className="mt-4 text-center text-sm text-gray-600">
              Didn’t get SMS?{" "}
              <button
                type="button"
                className="font-semibold underline hover:text-indigo-500"
                onClick={onResend}
              >
                SEND AGAIN
              </button>
            </div>
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
